import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from './Icons';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'terms' | 'privacy' | 'refund' | null;
}
export function LegalModals({
  isOpen,
  onClose,
  type
}: LegalModalProps) {
  if (!isOpen || !type) return null;
  const content = {
    terms: {
      title: 'Términos y Condiciones',
      date: 'Enero 2025',
      body: <div className="space-y-4 font-inter text-warm-muted" data-id="element-181">
          <p data-id="element-182">
            <strong className="text-warm-white" data-id="element-183">1. ACEPTACIÓN:</strong> Al
            adquirir El Protocolo RNS confirmas haber leído y aceptado estos
            términos.
          </p>
          <p data-id="element-184">
            <strong className="text-warm-white" data-id="element-185">2. PRODUCTO:</strong> El
            Protocolo RNS es un libro digital PDF de carácter educativo. No
            constituye asesoramiento médico, psicológico ni financiero
            profesional.
          </p>
          <p data-id="element-186">
            <strong className="text-warm-white" data-id="element-187">3. ENTREGA:</strong> El producto
            se entrega en formato PDF al email proporcionado en menos de 5
            minutos tras la compra.
          </p>
          <p data-id="element-188">
            <strong className="text-warm-white" data-id="element-189">
              4. PROPIEDAD INTELECTUAL:
            </strong>{' '}
            Todo el contenido es propiedad exclusiva de VitalyForms. Queda
            prohibida su reproducción o venta sin autorización escrita.
          </p>
          <p data-id="element-190">
            <strong className="text-warm-white" data-id="element-191">5. REEMBOLSOS:</strong>{' '}
            VitalyForms ofrece garantía de devolución de 30 días desde la
            compra.
          </p>
          <p data-id="element-192">
            <strong className="text-warm-white" data-id="element-193">6. LIMITACIÓN:</strong>{' '}
            VitalyForms no garantiza resultados específicos. Los resultados
            dependen del compromiso individual.
          </p>
          <p data-id="element-194">
            <strong className="text-warm-white" data-id="element-195">7. CONTACTO:</strong>{' '}
            soporte@vitalyforms.com
          </p>
        </div>
    },
    privacy: {
      title: 'Política de Privacidad',
      date: 'Enero 2025',
      body: <div className="space-y-4 font-inter text-warm-muted" data-id="element-196">
          <p data-id="element-197">
            <strong className="text-warm-white" data-id="element-198">
              1. DATOS QUE RECOPILAMOS:
            </strong>{' '}
            Nombre y email para entrega. Datos de pago procesados por procesador
            externo seguro.
          </p>
          <p data-id="element-199">
            <strong className="text-warm-white" data-id="element-200">2. USO DE DATOS:</strong>{' '}
            Entrega del producto, comunicaciones de compra y mejora de
            productos.
          </p>
          <p data-id="element-201">
            <strong className="text-warm-white" data-id="element-202">3. COMPARTIR DATOS:</strong> No
            vendemos datos personales sin consentimiento.
          </p>
          <p data-id="element-203">
            <strong className="text-warm-white" data-id="element-204">4. TUS DERECHOS:</strong>{' '}
            Solicita acceso o eliminación en soporte@vitalyforms.com
          </p>
          <p data-id="element-205">
            <strong className="text-warm-white" data-id="element-206">5. COOKIES:</strong> Solo
            cookies esenciales y análisis anónimos.
          </p>
        </div>
    },
    refund: {
      title: 'Política de Reembolso',
      date: 'Enero 2025',
      body: <div className="space-y-4 font-inter text-warm-muted" data-id="element-207">
          <p data-id="element-208">
            <strong className="text-warm-white" data-id="element-209">GARANTÍA DE 7 DÍAS:</strong> Si
            El Protocolo RNS no cumplió tus expectativas tienes 30 días
            calendario desde la compra para solicitar devolución completa.
          </p>
          <p data-id="element-210">
            <strong className="text-warm-white" data-id="element-211">CÓMO SOLICITARLO:</strong> Email
            a soporte@vitalyforms.com con asunto Solicitud de Reembolso y número
            de pedido.
          </p>
          <p data-id="element-212">
            <strong className="text-warm-white" data-id="element-213">TIEMPO:</strong> 3 a 5 días
            hábiles tras aprobación.
          </p>
          <p data-id="element-214">
            <strong className="text-warm-white" data-id="element-215">CONDICIONES:</strong> Dentro de
            30 días de la compra. Un reembolso por cliente. Sin justificación
            requerida.
          </p>
        </div>
    }
  };
  const currentContent = content[type];
  return <AnimatePresence data-id="element-216">
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-217">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-primary/80 backdrop-blur-sm" data-id="element-218" />

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-2xl bg-secondary border border-card rounded-2xl shadow-2xl overflow-hidden z-10 max-h-[90vh] flex flex-col" data-id="element-219">
          <div className="flex items-center justify-between p-6 border-b border-card" data-id="element-220">
            <div data-id="element-221">
              <h2 className="font-playfair font-bold text-2xl text-warm-white" data-id="element-222">
                {currentContent.title}
              </h2>
              <p className="font-inter text-sm text-warm-disabled mt-1" data-id="element-223">
                Última actualización: {currentContent.date}
              </p>
            </div>
            <button onClick={onClose} className="p-2 text-warm-muted hover:text-warm-white hover:bg-card rounded-full transition-colors" data-id="element-224">
              <XIcon className="w-6 h-6" data-id="element-225" />
            </button>
          </div>

          <div className="p-6 overflow-y-auto" data-id="element-226">{currentContent.body}</div>

          <div className="p-6 border-t border-card bg-primary/50 flex justify-end" data-id="element-227">
            <button onClick={onClose} className="px-6 py-2 bg-card hover:bg-card/80 text-warm-white font-inter font-semibold rounded transition-colors" data-id="element-228">
              Cerrar
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>;
}